export default __webpack_public_path__ + "126651017d87924d3d5f13db6de51bc7.png";